export default __webpack_public_path__ + "static/media/itchbook-grey-14px.45300828.svg";